export const ORG_SWITCH_STORAGE_KEY = 'org-switch'
export const ORG_SWITCH_SESSION_KEY = 'org-switch-in-progress'

const INVALID_ORG_SWITCH_VALUES = new Set([null, 'undefined'])

/**
 * @returns {string | null} Partner org id stored during org switch, or null when absent.
 */
export function getOrgSwitchPartnerOrgId() {
  const value = localStorage.getItem(ORG_SWITCH_STORAGE_KEY)
  if (INVALID_ORG_SWITCH_VALUES.has(value)) {
    return null
  }
  return value
}

export function isOrgSwitchInProgress() {
  return getOrgSwitchPartnerOrgId() !== null
}

export function isOrgSwitchSessionActive() {
  const value = sessionStorage.getItem(ORG_SWITCH_SESSION_KEY)
  if (INVALID_ORG_SWITCH_VALUES.has(value)) {
    return false
  }
  return value != null
}

export function isOrgSwitchTransitionActive() {
  return isOrgSwitchInProgress() || isOrgSwitchSessionActive()
}

export function markOrgSwitchSession(orgId) {
  sessionStorage.setItem(ORG_SWITCH_SESSION_KEY, orgId)
}

export function markOrgSwitchTransition(orgId) {
  markOrgSwitchSession(orgId)
  localStorage.setItem(ORG_SWITCH_STORAGE_KEY, orgId)
}

export function clearOrgSwitchSession() {
  sessionStorage.removeItem(ORG_SWITCH_SESSION_KEY)
}

export function clearOrgSwitchPartner() {
  localStorage.removeItem(ORG_SWITCH_STORAGE_KEY)
}

export function clearOrgSwitch() {
  clearOrgSwitchPartner()
  clearOrgSwitchSession()
}
